/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

// ==================== In-App Notification ====================
export const LOAD_INAPP_NOTIFICATION = `${url}/LOAD_INAPP_NOTIFICATION`;
export const LOAD_INAPP_NOTIFICATION_SUCCESS = `${url}/LOAD_INAPP_NOTIFICATION_SUCCESS`;
export const LOAD_INAPP_NOTIFICATION_ERROR = `${url}/LOAD_INAPP_NOTIFICATION_ERROR`;

export const CREATE_INAPP_NOTIFICATION = `${url}/CREATE_INAPP_NOTIFICATION`;
export const CREATE_INAPP_NOTIFICATION_SUCCESS = `${url}/CREATE_INAPP_NOTIFICATION_SUCCESS`;
export const CREATE_INAPP_NOTIFICATION_ERROR = `${url}/CREATE_INAPP_NOTIFICATION_ERROR`;

export const UPDATE_INAPP_NOTIFICATION = `${url}/UPDATE_INAPP_NOTIFICATION`;
export const UPDATE_INAPP_NOTIFICATION_SUCCESS = `${url}/UPDATE_INAPP_NOTIFICATION_SUCCESS`;
export const UPDATE_INAPP_NOTIFICATION_ERROR = `${url}/UPDATE_INAPP_NOTIFICATION_ERROR`;

export const DELETE_INAPP_NOTIFICATION = `${url}/DELETE_INAPP_NOTIFICATION`;
export const DELETE_INAPP_NOTIFICATION_SUCCESS = `${url}/DELETE_INAPP_NOTIFICATION_SUCCESS`;
export const DELETE_INAPP_NOTIFICATION_ERROR = `${url}/DELETE_INAPP_NOTIFICATION_ERROR`;

// ==================== Push Notification ====================
export const LOAD_PUSH_NOTIFICATION = `${url}/LOAD_PUSH_NOTIFICATION`;
export const LOAD_PUSH_NOTIFICATION_SUCCESS = `${url}/LOAD_PUSH_NOTIFICATION_SUCCESS`;
export const LOAD_PUSH_NOTIFICATION_ERROR = `${url}/LOAD_PUSH_NOTIFICATION_ERROR`;

export const CREATE_PUSH_NOTIFICATION = `${url}/CREATE_PUSH_NOTIFICATION`;
export const CREATE_PUSH_NOTIFICATION_SUCCESS = `${url}/CREATE_PUSH_NOTIFICATION_SUCCESS`;
export const CREATE_PUSH_NOTIFICATION_ERROR = `${url}/CREATE_PUSH_NOTIFICATION_ERROR`;

export const UPDATE_PUSH_NOTIFICATION = `${url}/UPDATE_PUSH_NOTIFICATION`;
export const UPDATE_PUSH_NOTIFICATION_SUCCESS = `${url}/UPDATE_PUSH_NOTIFICATION_SUCCESS`;
export const UPDATE_PUSH_NOTIFICATION_ERROR = `${url}/UPDATE_PUSH_NOTIFICATION_ERROR`;

export const DELETE_PUSH_NOTIFICATION = `${url}/DELETE_PUSH_NOTIFICATION`;
export const DELETE_PUSH_NOTIFICATION_SUCCESS = `${url}/DELETE_PUSH_NOTIFICATION_SUCCESS`;
export const DELETE_PUSH_NOTIFICATION_ERROR = `${url}/DELETE_PUSH_NOTIFICATION_ERROR`;

export const LOAD_NOTIFY_RECORDS_META_DATA = `${url}/LOAD_NOTIFY_RECORDS_META_DATA`
export const LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS`
export const LOAD_NOTIFY_RECORDS_META_DATA_ERROR = `${url}/LOAD_NOTIFY_RECORDS_META_DATA_ERROR`
// ==================== Constants Object ====================
const constants = {
  // In-App Notification
  LOAD_INAPP_NOTIFICATION,
  LOAD_INAPP_NOTIFICATION_SUCCESS,
  LOAD_INAPP_NOTIFICATION_ERROR,

  CREATE_INAPP_NOTIFICATION,
  CREATE_INAPP_NOTIFICATION_SUCCESS,
  CREATE_INAPP_NOTIFICATION_ERROR,

  UPDATE_INAPP_NOTIFICATION,
  UPDATE_INAPP_NOTIFICATION_SUCCESS,
  UPDATE_INAPP_NOTIFICATION_ERROR,

  DELETE_INAPP_NOTIFICATION,
  DELETE_INAPP_NOTIFICATION_SUCCESS,
  DELETE_INAPP_NOTIFICATION_ERROR,

  // Push Notification
  LOAD_PUSH_NOTIFICATION,
  LOAD_PUSH_NOTIFICATION_SUCCESS,
  LOAD_PUSH_NOTIFICATION_ERROR,

  CREATE_PUSH_NOTIFICATION,
  CREATE_PUSH_NOTIFICATION_SUCCESS,
  CREATE_PUSH_NOTIFICATION_ERROR,

  UPDATE_PUSH_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION_SUCCESS,
  UPDATE_PUSH_NOTIFICATION_ERROR,

  DELETE_PUSH_NOTIFICATION,
  DELETE_PUSH_NOTIFICATION_SUCCESS,
  DELETE_PUSH_NOTIFICATION_ERROR,

  LOAD_NOTIFY_RECORDS_META_DATA,
  LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS,
  LOAD_NOTIFY_RECORDS_META_DATA_ERROR,
};

export default constants;
